<template>
  <div class="home-box">
    <left-nav :isCollapse="isCollapse" :leftWidth="leftWidth" />
    <div class="right" :style="{width: `calc(100% - ${leftWidth + 1}px)`}">
      <top-nav @change-collapse="isCollapseChange" />
      
      <div style="height: calc(100vh - 81px);background:#F4F4F4;padding:10px;">
        <el-card :body-style="{padding: 0, height: 'calc(100vh - 81px)', 'overflowY': 'auto'}" >
          <router-view></router-view>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";

import LeftNav from '@/views/profile/LeftNav.vue';
import TopNav from '@/views/profile/TopNav.vue';

export default defineComponent({
  components: { LeftNav, TopNav },
  setup() {
    const isCollapse = ref(false);
    return { isCollapse }
  },
  data() {
    return {
    };
  },
  computed: {
    leftWidth() {
      return this.isCollapse ? 60 : 230;
    }
  },
  methods: {
    isCollapseChange() {
      this.isCollapse = !this.isCollapse;
    }
  }
});
</script>

<style lang="scss" scoped>
.home-box {
  width: 100%;
  height: 100%;
  display: flex;
  
  .right {
    height: 100%;
  }
}
</style>

<style lang="scss">
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
    background-color: #0003;
    border-radius: 10px;
    transition: all .2s ease-in-out;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  display: none;
}
</style>